import { useDispatch } from 'react-redux';
import React, { useCallback } from 'react';

import { manageColumnConfiguration } from '../../../store/shipments/grid/shipments.grid.actions';
import EditColumnsButton from '../index';
import { EditShipmentColumnsModalContainer } from '../../../containers/edit-shipment-columns-modal-container';
import { useModal } from '../../../hooks/use-modal';

const EditShipmentsGridColumnsButton = () => {
  const dispatch = useDispatch();
  const { close, isOpen, open } = useModal();
  const onClick = useCallback(() => {
    open();
    // For AnalyticsService
    dispatch(manageColumnConfiguration());
  }, [dispatch, open]);

  return (
    <React.Fragment>
      <EditColumnsButton onClick={onClick} />
      {isOpen && <EditShipmentColumnsModalContainer onClose={close} />}
    </React.Fragment>
  );
};

export default EditShipmentsGridColumnsButton;
